import { z } from "zod";

// One position from a restaurant menu. `nameTranslated` mirrors `name` when
// the source language already matches the user's target language.
// `priceText` is free-form (e.g. "12,50 €", "zł 8.00") — never int cents,
// because Claude unreliably converts decimals to integers.
export const MenuItemSchema = z.object({
  name: z.string().min(1).max(200),
  nameTranslated: z.string().min(1).max(200),
  description: z.string().max(400).nullable(),
  descriptionTranslated: z.string().max(400).nullable(),
  estimatedKcal: z.number().int().min(0).max(8000),
  estimatedProteinG: z.number().min(0).max(300).nullable(),
  estimatedFatG: z.number().min(0).max(300).nullable(),
  estimatedCarbsG: z.number().min(0).max(500).nullable(),
  priceText: z.string().max(30).nullable(),
  currency: z.string().max(5).nullable(),
  confidence: z.number().min(0).max(1),
});
export type MenuItem = z.infer<typeof MenuItemSchema>;

export const MenuPhotoResponseSchema = z.object({
  items: z.array(MenuItemSchema).max(40),
  detectedLanguage: z.string().max(10).nullable(),
});
export type MenuPhotoResponse = z.infer<typeof MenuPhotoResponseSchema>;

// Up to 3 photos — restaurant menus are often multi-page; sending each
// page lets the model see the whole card and miss fewer positions.
export const MenuPhotoInputSchema = z.object({
  imageDataUrls: z.array(z.string().min(1)).min(1).max(3),
  targetLanguage: z.string().max(10).default("pl"),
});
export type MenuPhotoInput = z.infer<typeof MenuPhotoInputSchema>;
